import React from "react";
import logo from "../../assets/images/logo.svg";
import graphics from "../../assets/images/graphics-1.svg";
import { Link } from "react-router-dom";
import tick from "../../assets/images/tick.svg";
import { Row, Col } from "antd";
const Home = () => {
  return (
    <div className="welcome-page">
      <div className="welcome-container">
        <header className="welcome-header">
          <div className="home-logo">
            <img src={logo} alt="" />
          </div>
          <div className="home-action ">
            <div className="btn-group">
              <Link to="/Login">
                <button className="btn btn-border">Login</button>
              </Link>
            </div>
          </div>
        </header>
        <div className="welcome-text">
          <Row gutter={48} align="middle">
            <Col span={12}>
              <h1>Primary Caregivers Autism spectrum of solutions</h1>
              <ul>
                <li>
                  <img width="30" src={tick} alt="" /> Do you have a difficult
                  time connecting with your child?
                </li>
                <li>
                  <img width="30" src={tick} alt="" /> Is he/she not showing any
                  focus or attention for the items or people around him?
                </li>
                <li>
                  <img width="30" src={tick} alt="" /> Is he/she not responding
                  well to SLP or ABA Therapy.
                </li>
                <li>
                  <img width="30" src={tick} alt="" /> He/she can’t speak and is
                  not using sign language, PECS or ACC apps for communication.
                </li>
              </ul>
              <p>
                <b>
                  If you have answered YES to anyone of the questions, please
                  create an Account and Login!
                </b>
              </p>
              <div className="btn-group">
                <Link to="/Login">
                  {" "}
                  <button className="btn btn-border">Login</button>
                </Link>
              </div>
            </Col>
            <Col span={12}>
              <img src={graphics} alt="" />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};
export default Home;
